import src from "IMAGE";
export default { src, width: 88, height: 88, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAR0lEQVR42o2PsQkAQAgD3X8qVxB7wdYdNI/f2bwvpLlINIRlqKoQEXD3oWbtUWZCVcHMQ83auwlmBhEZanYT1oWvE88nt5oHTAbtMYiYsosAAAAASUVORK5CYII="};
